import { styled } from "../../stitches.config";
import { Box, FlexBox } from "../primitives";

export const ContentWrapper = styled(Box, {
  display: "flex",
  gap: 10,
  justifyContent: "space-between",
  height: "100%",
});

export const NoProductFound = styled(Box, {
  textAlign: "center",
  textTransform: "uppercase",
  fontWeight: "bolder",
  fontSize: 18,
  marginTop: "40px",
});

export const TableRow = styled(FlexBox, {
  justifyContent: "space-between",
  alignItems: "center",
  padding: 10,
  width: "100%",
  cursor: "pointer",
  position: "relative",
  zIndex: 1,
  transition: "box-shadow 0.2s ease, background 0.2s ease",
  "&:hover": {
    background: "#D1FAE5",
  },
  variants: {
    isEven: {
      true: { background: "#E5E7EB" },
      false: { background: "#FFFFFF" },
    },
  },
});
